import { alpha, styled } from '@mui/material/styles';

export const AlertsContainer = styled('div')({
  maxWidth: 1000,
  margin: '0 auto',
});

export const AlertsHeaderRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  fontSize: 13,
  minHeight: 30,
  boxSizing: 'border-box',
  padding: theme.spacing(1),
  cursor: 'pointer',
  '&:hover': {
    opacity: 0.7,
  },
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const AlertsFlexRow = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

// Row supports a `showbg` flag and a `newRow` flag (for the new-alert highlight).
export const AlertsRow = styled('div', {
  shouldForwardProp: (p) => !['showbg', 'newRow'].includes(p),
})(({ theme, showbg, newRow }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  fontSize: 13,
  minHeight: 30,
  boxSizing: 'border-box',
  padding: theme.spacing(1),
  cursor: 'pointer',

  '&:hover': {
    opacity: 0.7,
  },

  ...(showbg ? { backgroundColor: theme.palette.action.disabledBackground } : {}),
  ...(newRow
    ? { backgroundColor: showbg ? alpha(theme.palette.error.main, 0.4) : alpha(theme.palette.error.main, 0.2) }
    : {}),
}));

export const AlertsInfo = styled('div')(({ theme }) => ({
  width: '85%',
  display: 'flex',
  paddingRight: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const AlertsTime = styled('div')({
  width: '15%',
});

export const AlertsType = styled('div', {
  shouldForwardProp: (p) => p !== 'header',
})(({ theme, header }) => ({
  width: '20%',
  marginTop: theme.spacing(0.5),
  [theme.breakpoints.down('md')]: {
    width: '100%',
    ...(header ? { display: 'none' } : {}),
  },
}));

export const AlertsLocation = styled('div', {
  shouldForwardProp: (p) => p !== 'header',
})(({ theme, header }) => ({
  width: '25%',
  marginTop: theme.spacing(0.5),
  marginRight: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    width: '100%',
    marginRight: 0,
    ...(header ? { display: 'none' } : {}),
  },
}));

export const AlertsDescription = styled('div')(({ theme }) => ({
  flexGrow: 1,
  marginTop: theme.spacing(0.5),
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

export const AlertsLocationContainer = styled('div', {
  shouldForwardProp: (p) => p !== 'locationOn',
})(({ theme, locationOn }) => ({
  backgroundColor: locationOn ? theme.palette.success.light : theme.palette.action.disabled,
  borderRadius: 10,
  maxWidth: 500,
  margin: '10px auto',
  padding: `5px 10px`,
  position: 'relative',

  '& .MuiIcon-root': {
    position: 'absolute',
    top: 10,
    left: 8,
    color: theme.palette.common.black,
  },
}));

export const AlertsLocationContent = styled('div')(({ theme }) => ({
  marginLeft: theme.spacing(3),

  '& p': {
    fontSize: 12,
    color: theme.palette.common.black,
  },
  '& .MuiFormControlLabel-label': {
    fontWeight: 'bold',
    color: theme.palette.grey[700],
    fontSize: 14,
  },
}));
